import { toast } from 'react-toastify';

import moment from 'moment';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestOperacaoExtratoDadosCapaTnqPostos({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'extradadoscapatnqpostos', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteOperacaoExtratoDadosCapaTnqPostos({ payload }) {
  try {
    const { codigoposto, params } = payload;

    yield call(api.delete, `extradadoscapatnqpostos/${codigoposto}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { operacaoextratodadoscapatnqpostos, params } = payload;

    yield call(
      api.post,
      'extradadoscapatnqpostos',
      operacaoextratodadoscapatnqpostos
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/extradadoscapatnqpostos');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { codigoposto } = payload;

    const { data } = yield call(
      api.get,
      `extradadoscapatnqpostos/${codigoposto}`
    );

    const dataMod = {
      ...data,
      datahorainicialmovimentacao: moment(
        data.datahorainicialmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
      datahorafinalmovimentacao: moment(
        data.datahorafinalmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
    };

    yield put(successRequest(dataMod));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { operacaoextratodadoscapatnqpostos, params } = payload;

    yield call(
      api.put,
      'extradadoscapatnqpostos',
      operacaoextratodadoscapatnqpostos
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/extradadoscapatnqpostos');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'extradadoscapatnqpostos', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest(
    '@operacaoextratodadoscapatnqpostos/EXTRADADOSCAPATNQPOSTOS_IN_REQUEST',
    requestOperacaoExtratoDadosCapaTnqPostos
  ),
  takeLatest(
    '@operacaoextratodadoscapatnqpostos/DELETE_EXTRADADOSCAPATNQPOSTOS',
    deleteOperacaoExtratoDadosCapaTnqPostos
  ),
  takeLatest(
    '@operacaoextratodadoscapatnqpostos/SUCCESS_REMOVE',
    requestOperacaoExtratoDadosCapaTnqPostos
  ),
  takeLatest(
    '@operacaoextratodadoscapatnqpostos/STORE_EXTRADADOSCAPATNQPOSTOS',
    store
  ),
  takeLatest(
    '@operacaoextratodadoscapatnqpostos/FIND_EXTRADADOSCAPATNQPOSTOS',
    find
  ),
  takeLatest(
    '@operacaoextratodadoscapatnqpostos/UPDATE_EXTRADADOSCAPATNQPOSTOS',
    update
  ),
  takeLatest(
    '@operacaoextratodadoscapatnqpostos/RECORD_FILTERING',
    applyedFilters
  ),
]);
